/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";
import { withMyTheme } from "../../theme/theme";
import { css } from "@emotion/react";
import { mobileCss } from "../../util/isMobile";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FeatureData } from "./FeatureList";

const MobileSelectContainerStyle = withMyTheme(() => css`
  display: none;
  ${mobileCss(`
    display: block;
    width: 90%;
    margin: 0 auto 0rem auto;
  `)}
`);

const MobileSelectStyle = withMyTheme((theme) => css`
  .MuiOutlinedInput-root {
    border-radius: 20px;
    background-color: white;
    transition: all 0.3s ease;
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.palette.primary.main};
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.palette.primary.main};
      border-width: 2px;
    }
  }
  
  .MuiSelect-select {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
  }
  
  .MuiInputLabel-root {
    transform: translate(14px, -9px) scale(0.75);
    background-color: white;
    padding: 0 8px;
    color: rgba(0, 0, 0, 0.6);
    
    &.Mui-focused {
      color: ${theme.palette.primary.main};
    }
  }
  
  .MuiOutlinedInput-notchedOutline {
    legend {
      visibility: visible;
    }
  }
`);

const MenuItemStyle = withMyTheme((theme) => css`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  
  &.Mui-selected {
    background-color: ${theme.palette.action.selected};
    
    &:hover {
      background-color: ${theme.palette.action.hover};
    }
  }
  
  .MuiSvgIcon-root {
    color: ${theme.palette.primary.main};
  }
`);

export const FeatureSelect = ({selectedFeature, handleSelectChange, featureData}: {selectedFeature: FeatureData, handleSelectChange: (event: SelectChangeEvent<string>) => void, featureData: FeatureData[]}) => {
    const { t } = useTranslation();
    return (
      <div css={MobileSelectContainerStyle}>
              <FormControl fullWidth css={MobileSelectStyle}>
                <InputLabel 
                  id="feature-select-label"
                  shrink
                >
                  {t('features.selectLabel')}
                </InputLabel>
                <Select
                  labelId="feature-select-label"
                  id="feature-select"
                  value={selectedFeature.id}
                  label={t('features.selectLabel')}
                  notched
                  onChange={handleSelectChange}
                  renderValue={(selected) => {
                    const feature = featureData.find(f => f.id === selected);
                    return (
                      <>
                        {feature?.icon}
                        <span>{feature?.buttonName}</span>
                      </>
                    );
                  }}
                >
                  {featureData.map((feature) => (
                    <MenuItem 
                      key={feature.id} 
                      value={feature.id}
                      css={MenuItemStyle}
                    >
                      {feature.icon}
                      <span>{feature.buttonName}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
    );
  };